import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import FieldLabel from "./FieldLabel";
import { LabelProps } from "./Types";

const Field: React.FC<LabelProps> = ({ text, required, labelSize, children }) => {

    if (labelSize === 'auto') {
        return (
            <Form.Group as={Row} className="form-field">
                <FieldLabel text={text} required={required} labelSize={labelSize} />
                <>
                    {children}
                </>
            </Form.Group>
        );
    }

    return (
        <Form.Group as={Row} className="form-field">
            <FieldLabel text={text} required={required} labelSize={labelSize} />
            <Col sm={12 - labelSize} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <>
                    {children}
                </>
            </Col>
        </Form.Group>
    );
}
export default Field;